import { Grid, TextField } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty, isNil } from 'lodash';
import { Listings } from 'containers/AppContainer/typings';
import {
  BENEFICIARY,
  JUDGEMENT_BENEFICIARY_FIELDS,
} from 'containers/data-structure';
import messages from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/messages';
import {
  getBeneficiaryContestations,
  isDeceasedVictimContested,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import BeneficiaryContestationDialog from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/beneficiaryContestationDialog';
import { BUTTON_COLORS } from 'constants/design';
import { VictimType } from 'typings/globalTypes';
import { getValueByCode } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { FEES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/data-structure';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';

export interface BeneficiaryWithCompensationProps {
  intl: IntlShape;
  listings: Listings;
  beneficiary: any;
  index: any;
  judgementOnMerits: any;
  isManager: boolean;
  deceasedVictimsToShow: any;
  setDeceasedVictimsToShow: Function;
  victim: VictimType;
  showFuneralFees: any;
  setShowFuneralFees: Function;
  associatedVictims: any;
  lossDate: any;
  handleChangeBeneficiaries: Function;
  isRecap: Boolean;
  RecapInfo: any;
  beneficiaryContestationReasons: any;
  setBeneficiaryContestationReasons?: Function;
  handleChange: Function;
}
export const beneficiaryStyle = {
  width: '100%',
  marginTop: '10px',
  paddingBottom: '30px',
  paddingTop: '20px',
  paddingLeft: '20px',
  boxShadow: '0px 1px 3px #0880bc',
  borderRadius: '4px',
};

const BeneficiaryInfo: React.FC<BeneficiaryWithCompensationProps> = ({
  beneficiary,
  index,
  ...props
}): JSX.Element => {
  const [indexBeneficiary, setIndexBeneficiary] = React.useState<Number>(0);

  const [
    isContestationDialogOpen,
    setIsContestationDialogOpen,
  ] = React.useState<boolean>(false);

  const handleOpenContestation = (index: Number) => () => {
    setIsContestationDialogOpen(true);
    setIndexBeneficiary(index);
  };

  return (
    <>
      {!get(
        props.showFuneralFees[get(props.victim, 'id') as any],
        FEES.FUNERAL_BENEFICIARY_FEES,
        false,
      ) && (
        <Grid item xs={3}>
          <TextField
            label={translate(messages.victimFrais, props)}
            type="number"
            name={BENEFICIARY.FRAIS}
            onChange={props.handleChange(beneficiary.victimId, index)}
            value={get(beneficiary, [BENEFICIARY.FRAIS], null)}
            className="input"
          />
        </Grid>
      )}
      {!get(
        props.showFuneralFees[get(props.victim, 'id') as any],
        FEES.MEDICAL_BENEFICIARY_FEES,
        false,
      ) &&
        featureService.hasFeature(FEATURES.JUDGEMENT_ON_MERITS_INFO) && (
          <Grid item xs={3}>
            <TextField
              label={translate(messages.medicalFees, props)}
              type="number"
              name={BENEFICIARY.MEDICAL_FFES}
              onChange={props.handleChange(beneficiary.victimId, index)}
              value={get(beneficiary, [BENEFICIARY.MEDICAL_FFES], null)}
              className="input"
            />
          </Grid>
        )}
      <Grid item xs={3}>
        <TextField
          label={translate(messages.judgementAmountBeneficiary, props)}
          type="number"
          name={JUDGEMENT_BENEFICIARY_FIELDS.JUDGEMENT_AMOUNT}
          onChange={props.handleChange(beneficiary.victimId, index)}
          value={get(
            beneficiary,
            [JUDGEMENT_BENEFICIARY_FIELDS.JUDGEMENT_AMOUNT],
            null,
          )}
          error={
            !get(
              beneficiary,
              [JUDGEMENT_BENEFICIARY_FIELDS.JUDGEMENT_AMOUNT],
              null,
            )
          }
          className="input"
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          type="number"
          name={JUDGEMENT_BENEFICIARY_FIELDS.PREJUDICE_MORAL}
          label={translate(messages.calculatedPrejudiceMoralTitle, props)}
          value={get(beneficiary, 'calculatedMoralePrejudice')}
          className="input"
          InputProps={{
            readOnly: true,
          }}
          InputLabelProps={{
            shrink: !isNil(get(beneficiary, 'calculatedMoralePrejudice')),
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          type="number"
          name={JUDGEMENT_BENEFICIARY_FIELDS.PREJUDICE_MORAL}
          label={translate(messages.prejudiceMoralTitle, props)}
          onChange={props.handleChange(beneficiary.victimId, index)}
          value={get(beneficiary, BENEFICIARY.PREJUDICE_MORAL, '')}
          InputLabelProps={{
            shrink: !isNil(get(beneficiary, BENEFICIARY.PREJUDICE_MORAL, '')),
          }}
          className="input"
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          type="number"
          name={JUDGEMENT_BENEFICIARY_FIELDS.PREJUDICE_MATERIEL}
          label={translate(messages.calculatedPrejudiceMaterielTitle, props)}
          value={get(beneficiary, 'calculatedMaterialPrejudice')}
          className="input"
          InputLabelProps={{
            shrink: !isNil(get(beneficiary, 'calculatedMaterialPrejudice')),
          }}
          InputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          name={JUDGEMENT_BENEFICIARY_FIELDS.PREJUDICE_MATERIEL}
          type="number"
          label={translate(messages.prejudiceMaterielTitle, props)}
          onChange={props.handleChange(beneficiary.victimId, index)}
          value={get(beneficiary, BENEFICIARY.PREJUDICE_MATERIEL, '')}
          InputLabelProps={{
            shrink: !isNil(
              get(beneficiary, BENEFICIARY.PREJUDICE_MATERIEL, ''),
            ),
          }}
          className="input"
        />
      </Grid>
      <Grid direction="column" className="display-decision">
        {props.isRecap &&
          !isEmpty(
            getBeneficiaryContestations(beneficiary, props.RecapInfo),
          ) && (
            <Grid item xs={2}>
              <section className="judgement-on-merits-contestation-container">
                <h4 className="contestation-container-title">
                  {translate(messages.decision, props)}
                </h4>
                <article className="contestation-status">
                  <span className="contestation-sub-bloc-title">
                    {translate(messages.status, props)}
                  </span>
                  <span>{translate(messages.challenged, props)}</span>
                  <div className="contestation-reason">
                    <span className="contestation-sub-bloc-title">
                      {translate(messages.contestationReason, props)}
                    </span>
                  </div>
                  {getBeneficiaryContestations(
                    beneficiary,
                    props.RecapInfo,
                  ).map((motif: any) => {
                    /* istanbul ignore next */
                    return (
                      <div className="contestation-reason">
                        <span>
                          {getValueByCode(
                            get(
                              motif,
                              'judgementOnMeritsBeneficiaryContestationReasonId',
                            ),
                            get(
                              props.listings,
                              'judgementOnMeritsBeneficiaryContestationReason',
                              [],
                            ),
                          )}
                        </span>
                      </div>
                    );
                  })}

                  <div className="contestation-reason">
                    <span className="contestation-sub-bloc-title">
                      {translate(messages.contestationInstruction, props)}
                    </span>
                  </div>
                  {getBeneficiaryContestations(
                    beneficiary,
                    props.RecapInfo,
                  ).map((motif: any) => {
                    return (
                      <div className="contestation-reason">
                        <span>{get(motif, 'instruction')}</span>
                      </div>
                    );
                  })}
                </article>
              </section>
            </Grid>
          )}
        <Grid item xs={2}>
          {isDeceasedVictimContested(
            beneficiary,
            props.RecapInfo,
            props.beneficiaryContestationReasons,
          ) &&
            !isNil(get(beneficiary, 'id', null)) &&
            props.isRecap &&
            props.isManager && (
              <PrimaryButton
                background={BUTTON_COLORS.GOLDEN_BUTTON_TITLE}
                border={BUTTON_COLORS.GOLDEN_BUTTON_TITLE}
                titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                title={translate(messages.challenged, props)}
                onClick={handleOpenContestation(
                  Number(
                    get(
                      props.RecapInfo.find(
                        /* istanbul ignore next */
                        (benef: any) =>
                          benef.beneficiaryIdJom ===
                          beneficiary.beneficiaryIdJom,
                      ) || {},
                      'beneficiaryIdJom',
                      0,
                    ),
                  ),
                )}
              />
            )}
        </Grid>
      </Grid>
      {!isDeceasedVictimContested(
        beneficiary,
        props.RecapInfo,
        props.beneficiaryContestationReasons,
      ) &&
        !isNil(get(beneficiary, 'id', null)) &&
        props.isRecap &&
        props.isManager && (
          <Grid item xs={2}>
            <PrimaryButton
              background={BUTTON_COLORS.PRIMARY_BLUE}
              border={BUTTON_COLORS.PRIMARY_BLUE}
              titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
              title={translate(messages.challenge, props)}
              onClick={handleOpenContestation(
                Number(
                  get(
                    props.RecapInfo.find(
                      (benef: any) =>
                        benef.beneficiaryIdJom === beneficiary.beneficiaryIdJom,
                    ) || {},
                    'beneficiaryIdJom',
                    0,
                  ),
                ),
              )}
            />
          </Grid>
        )}
      <BeneficiaryContestationDialog
        listings={props.listings}
        beneficiaryId={Number(indexBeneficiary)}
        setBeneficiaryContestationReasons={
          props.setBeneficiaryContestationReasons &&
          props.setBeneficiaryContestationReasons
        }
        isOpen={isContestationDialogOpen}
        beneficiaryContestationReasons={
          props.beneficiaryContestationReasons &&
          props.beneficiaryContestationReasons
        }
        setIsContestationDialogOpen={setIsContestationDialogOpen}
      />
    </>
  );
};

export default injectIntl(BeneficiaryInfo);
